import { Controller } from '@hotwired/stimulus';

import PaymentAccount from '@/modules/payment_account';

export default class extends Controller {
  connect() {
    new PaymentAccount().init();
  }
}
